export const AdsConfig: AdPageconfiguration = {
  durationInSeconds: 5
};

interface AdPageconfiguration {
  durationInSeconds: number;
}
